// JsaPpeInfo
export class JsaPpeInfo {
  constructor(data = {}) {
    this.ppeEyeFaceSafetyGlasses = data.ppe_eye_face_safety_glasses || false;
    this.ppeEyeFaceGoggles = data.ppe_eye_face_goggles || false;
    this.ppeEyeFaceFaceShield = data.ppe_eye_face_face_shield || false;
    this.ppeHearingEarPlugs = data.ppe_hearing_ear_plugs || false;
    this.ppeHearingEarMuffs = data.ppe_hearing_ear_muffs || false;
    this.ppeHeadHardHat = data.ppe_head_hard_hat || false;
    this.ppeHandLeather = data.ppe_hand_leather || false;
    this.ppeHandCutResistant = data.ppe_hand_cut_resistant || false;
    this.ppeHandChemicalResistant = data.ppe_hand_chemical_resistant || false;
    this.ppeHandOther = data.ppe_hand_other || false;
    this.ppeHandOtherInfo = data.ppe_hand_other_info || "";
    this.ppeFootSteelToe = data.ppe_foot_steel_toe || false;
    this.ppeFootMetatarsal = data.ppe_foot_metatarsal || false;
    this.ppeFootOther = data.ppe_foot_other || false;
    this.ppeFootOtherInfo = data.ppe_foot_other_info || "";
    this.ppeClothingNomex = data.ppe_clothing_nomex || false;
    this.ppeClothingTyvek = data.ppe_clothing_tyvek || false;
    this.ppeClothingSlickerSuit = data.ppe_clothing_slicker_suit || false;
    this.ppeClothingAcidSuit = data.ppe_clothing_acid_suit || false;
    this.ppeRespiratoryProtectionYes =
      data.ppe_respiratory_protection_yes || false;
    this.ppeRespiratoryProtectionNo =
      data.ppe_respiratory_protection_no || false;
    this.ppeRespiratorTypeHalfFace =
      data.ppe_respirator_type_half_face || false;
    this.ppeRespiratorTypeFullFace =
      data.ppe_respirator_type_full_face || false;
    this.ppeRespiratorTypeCartridge =
      data.ppe_respirator_type_cartridge || false;
    this.ppeRespiratorTypeScba = data.ppe_respirator_type_scba || false;
    this.ppeRespiratorTypeSuppliedAir =
      data.ppe_respirator_type_supplied_air || false;
    this.ppeComments = data.ppe_comments || "";
  }

  // Update functions
  updatePpeEyeFaceSafetyGlasses(value) {
    this.ppeEyeFaceSafetyGlasses = value;
  }

  updatePpeEyeFaceGoggles(value) {
    this.ppeEyeFaceGoggles = value;
  }

  updatePpeEyeFaceFaceShield(value) {
    this.ppeEyeFaceFaceShield = value;
  }

  updatePpeHearingEarPlugs(value) {
    this.ppeHearingEarPlugs = value;
  }

  updatePpeHearingEarMuffs(value) {
    this.ppeHearingEarMuffs = value;
  }

  updatePpeHeadHardHat(value) {
    this.ppeHeadHardHat = value;
  }

  updatePpeHandLeather(value) {
    this.ppeHandLeather = value;
  }

  updatePpeHandCutResistant(value) {
    this.ppeHandCutResistant = value;
  }

  updatePpeHandChemicalResistant(value) {
    this.ppeHandChemicalResistant = value;
  }

  updatePpeHandOther(value) {
    if (!value) {
      this.ppeHandOther = false;
      this.ppeHandOtherInfo = "";
    } else {
      this.ppeHandOther = value;
    }
  }

  updatePpeHandOtherInfo(value) {
    this.ppeHandOtherInfo = value;
  }

  updatePpeFootSteelToe(value) {
    this.ppeFootSteelToe = value;
  }

  updatePpeFootMetatarsal(value) {
    this.ppeFootMetatarsal = value;
  }

  updatePpeFootOther(value) {
    if (!value) {
      this.ppeFootOther = false;
      this.ppeFootOtherInfo = "";
    } else {
      this.ppeFootOther = value;
    }
  }

  updatePpeFootOtherInfo(value) {
    this.ppeFootOtherInfo = value;
  }

  updatePpeClothingNomex(value) {
    this.ppeClothingNomex = value;
  }

  updatePpeClothingTyvek(value) {
    this.ppeClothingTyvek = value;
  }

  updatePpeClothingSlickerSuit(value) {
    this.ppeClothingSlickerSuit = value;
  }

  updatePpeClothingAcidSuit(value) {
    this.ppeClothingAcidSuit = value;
  }

  updatePpeRespiratoryProtectionYes(value) {
    if (!value) {
      this.ppeRespiratoryProtectionYes = false;
      this.ppeRespiratorTypeHalfFace = false;
      this.ppeRespiratorTypeFullFace = false;
      this.ppeRespiratorTypeCartridge = false;
      this.ppeRespiratorTypeScba = false;
      this.ppeRespiratorTypeSuppliedAir = false;
    } else {
      this.ppeRespiratoryProtectionYes = value;
      this.ppeRespiratoryProtectionNo = false;
    }
  }

  updatePpeRespiratoryProtectionNo(value) {
    if (!value) {
      this.ppeRespiratoryProtectionNo = false;
    } else {
      this.ppeRespiratoryProtectionNo = value;
      this.ppeRespiratoryProtectionYes = false;
      this.ppeRespiratorTypeHalfFace = false;
      this.ppeRespiratorTypeFullFace = false;
      this.ppeRespiratorTypeCartridge = false;
      this.ppeRespiratorTypeScba = false;
      this.ppeRespiratorTypeSuppliedAir = false;
    }
  }

  updatePpeRespiratorTypeHalfFace(value) {
    this.ppeRespiratorTypeHalfFace = value;
  }

  updatePpeRespiratorTypeFullFace(value) {
    this.ppeRespiratorTypeFullFace = value;
  }

  updatePpeRespiratorTypeCartridge(value) {
    this.ppeRespiratorTypeCartridge = value;
  }

  updatePpeRespiratorTypeScba(value) {
    this.ppeRespiratorTypeScba = value;
  }

  updatePpeRespiratorTypeSuppliedAir(value) {
    this.ppeRespiratorTypeSuppliedAir = value;
  }

  updatePpeComments(value) {
    this.ppeComments = value;
  }

  // To json for sending to the database
  toJson() {
    return {
      ppe_eye_face_safety_glasses: this.ppeEyeFaceSafetyGlasses,
      ppe_eye_face_goggles: this.ppeEyeFaceGoggles,
      ppe_eye_face_face_shield: this.ppeEyeFaceFaceShield,
      ppe_hearing_ear_plugs: this.ppeHearingEarPlugs,
      ppe_hearing_ear_muffs: this.ppeHearingEarMuffs,
      ppe_head_hard_hat: this.ppeHeadHardHat,
      ppe_hand_leather: this.ppeHandLeather,
      ppe_hand_cut_resistant: this.ppeHandCutResistant,
      ppe_hand_chemical_resistant: this.ppeHandChemicalResistant,
      ppe_hand_other: this.ppeHandOther,
      ppe_hand_other_info: this.ppeHandOtherInfo,
      ppe_foot_steel_toe: this.ppeFootSteelToe,
      ppe_foot_metatarsal: this.ppeFootMetatarsal,
      ppe_foot_other: this.ppeFootOther,
      ppe_foot_other_info: this.ppeFootOtherInfo,
      ppe_clothing_nomex: this.ppeClothingNomex,
      ppe_clothing_tyvek: this.ppeClothingTyvek,
      ppe_clothing_slicker_suit: this.ppeClothingSlickerSuit,
      ppe_clothing_acid_suit: this.ppeClothingAcidSuit,
      ppe_respiratory_protection_yes: this.ppeRespiratoryProtectionYes,
      ppe_respiratory_protection_no: this.ppeRespiratoryProtectionNo,
      ppe_respirator_type_half_face: this.ppeRespiratorTypeHalfFace,
      ppe_respirator_type_full_face: this.ppeRespiratorTypeFullFace,
      ppe_respirator_type_cartridge: this.ppeRespiratorTypeCartridge,
      ppe_respirator_type_scba: this.ppeRespiratorTypeScba,
      ppe_respirator_type_supplied_air: this.ppeRespiratorTypeSuppliedAir,
      ppe_comments: this.ppeComments,
    };
  }

  // Helper for single and multi-field patches to be sent via websocket
  toPatch(fields, jsaId, action = "update") {
    const fieldMap = {
      ppeEyeFaceSafetyGlasses: "ppe_eye_face_safety_glasses",
      ppeEyeFaceGoggles: "ppe_eye_face_goggles",
      ppeEyeFaceFaceShield: "ppe_eye_face_face_shield",
      ppeHearingEarPlugs: "ppe_hearing_ear_plugs",
      ppeHearingEarMuffs: "ppe_hearing_ear_muffs",
      ppeHeadHardHat: "ppe_head_hard_hat",
      ppeHandLeather: "ppe_hand_leather",
      ppeHandCutResistant: "ppe_hand_cut_resistant",
      ppeHandChemicalResistant: "ppe_hand_chemical_resistant",
      ppeHandOther: "ppe_hand_other",
      ppeHandOtherInfo: "ppe_hand_other_info",
      ppeFootSteelToe: "ppe_foot_steel_toe",
      ppeFootMetatarsal: "ppe_foot_metatarsal",
      ppeFootOther: "ppe_foot_other",
      ppeFootOtherInfo: "ppe_foot_other_info",
      ppeClothingNomex: "ppe_clothing_nomex",
      ppeClothingTyvek: "ppe_clothing_tyvek",
      ppeClothingSlickerSuit: "ppe_clothing_slicker_suit",
      ppeClothingAcidSuit: "ppe_clothing_acid_suit",
      ppeRespiratoryProtectionYes: "ppe_respiratory_protection_yes",
      ppeRespiratoryProtectionNo: "ppe_respiratory_protection_no",
      ppeRespiratorTypeHalfFace: "ppe_respirator_type_half_face",
      ppeRespiratorTypeFullFace: "ppe_respirator_type_full_face",
      ppeRespiratorTypeCartridge: "ppe_respirator_type_cartridge",
      ppeRespiratorTypeScba: "ppe_respirator_type_scba",
      ppeRespiratorTypeSuppliedAir: "ppe_respirator_type_supplied_air",
      ppeComments: "ppe_comments",
    };

    const patch = {
      patch_type: "jsa_ppe_info",
      jsa_id: jsaId,
      action,
    };

    for (const [key, value] of Object.entries(fields)) {
      const dbField = fieldMap[key];
      if (dbField) {
        patch[dbField] = value;
      }
    }

    return patch;
  }
}
